import FreemiumEventLandingPageStep from './FreemiumEventLandingPageStep';

export default FreemiumEventLandingPageStep;
